<template>
	<div style="display: flex">
		<!-- Icône -->
		<v-icon
			:color="iconColor"
			style="height: 23px; width: 23px; min-height: 23px; min-width: 23px;"
		>
			{{ icon }}
		</v-icon>
		<!-- Texte -->
		<p style="margin-left: 5px !important;">
			{{ text }}
		</p>
	</div>
</template>

<script lang="ts">
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { VIcon } from 'vuetify/lib';

	/**
	 * Affiche une icône et un texte
	 */
	@Component({
		components: { VIcon }
	})
	export default class IconText extends Vue {
		// Icône à afficher
		@Prop({ default: '' })
		readonly icon!: string;

		// Couleur de l'icône
		@Prop({ default: '' })
		readonly iconColor!: string;

		// Texte à afficher à côté de l'icône
		@Prop({ default: '' })
		readonly text!: string;
	}
</script>

<style lang="css" scoped>
p {
	margin: 0 !important;
}
</style>
